import { COMPONENTS, EVENTS } from '../../../lib/constants';
import { GameConfigs } from '../../../lib/globals/GameConfigs';
import HELPERS from '../../../lib/globals/helpers/Helpers';
import { FastplayDialogueView } from '../../../view/fastplay-dialogue/FastplayDialogue';

export function showFastPlayDialogue(disable) {
	handleModal('fastplay_dialogue');
	GameConfigs.uiComponent.addView(FastplayDialogueView);
	GameConfigs.uiComponent[
		COMPONENTS.FAST_PLAY_DIALOGUE
	].CloseController.onClose(() => {
		GameConfigs.fastPlayDialogue = true;
		disable = false;
	});
}

export function handleModal(modal) {
	GameConfigs.modal = modal;
	HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: modal });
}
